import { Client, init, PickerOptions } from 'filestack-js';
import { sdkConfig } from '../config';

export default class FileStackService {
  private readonly fileStack: Client;

  constructor() {
    this.fileStack = init(sdkConfig.REACT_APP_FILESTACK_API_KEY);
  }

  public openFilePicker(options?: PickerOptions): Promise<void> {
    return this.fileStack.picker(options).open();
  }
}
